/**
 * Public credential verification API client.
 *
 * Wraps GET /api/verify/{credential_id}. The endpoint is anonymous —
 * no session cookie required — and serves the SPA route hosted at
 * verify.cait.academy/<credential_id>.
 */
import { apiGet } from "@/lib/api";

export interface VerifyPayload {
  credential_id: string;
  credential_type: string;
  credential_name: string;
  holder_display_name: string;
  issued_at: string;
  expires_at: string;
  status: "active" | "expired" | "lapsed" | "revoked";
  pdf_url: string;
  qr_code_url: string;
  is_currently_valid: boolean;
}

export async function fetchCredential(credentialId: string): Promise<VerifyPayload> {
  return apiGet<VerifyPayload>(`/api/verify/${encodeURIComponent(credentialId)}`);
}
